<template>
  <el-card>
    <el-form inline ref="searchForm" :model="searchForm">
      <el-form-item prop="serviceName">
        <el-input v-model="searchForm.itemName" placeholder="请输入物品名称" clearable></el-input>
      </el-form-item>
      <el-form-item prop="projectId">
        <el-select v-model="searchForm.projectId" placeholder="请选择公园名称" clearable filterable>
          <el-option v-for="(item, index) in parkList" :key="index" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="typeId">
        <el-select v-model="searchForm.state" placeholder="请选择物品状态" filterable clearable>
          <el-option label="未领走" value="0"></el-option>
          <el-option label="已领走" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>

    <div class="mb20">
      <el-button @click="onAdd" type="primary" icon="el-icon-plus" v-if="$ButtonShow('LOST_ADD_01')">添加物品</el-button>
    </div>

    <el-table class="global-table" v-loading="loading" :data="tableData">
      <el-table-column label="物品图片" show-overflow-tooltip prop="fileList">
        <template v-slot="{ row }">
          <el-image v-if="row.fileList && row.fileList[0]" :src="row.fileList[0].filePrefix + row.fileList[0].fileUrl"
            :preview-src-list="row.fileList | previewList" fit="fill"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="物品名称" show-overflow-tooltip prop="itemName"></el-table-column>
      <el-table-column label="所属公园" show-overflow-tooltip prop="projectName"></el-table-column>
      <el-table-column label="入库日期" show-overflow-tooltip prop="entryDate"></el-table-column>
      <el-table-column label="物品状态" show-overflow-tooltip prop="state">
        <template v-slot="{ row }">
          {{ row.state === '1' ? '已领走' : '未领走' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="onSetting(row)" v-if="row.state === '0' && $ButtonShow('LOST_EDT_01')">置为已领走</el-button>
          <el-button type="text" @click="onUpdate(row.id)" v-if="row.state === '0' && $ButtonShow('LOST_EDT_01')">编辑</el-button>
          <el-button type="text" @click="onDelete(row.id)" v-if="$ButtonShow('LOST_DEL_01')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <GlobalPagination @size-change="loadData" @current-change="loadData" :current-page.sync="page" :page-size.sync="size"
      :total="total">
    </GlobalPagination>
  </el-card>
</template>

<script>
import keepAlive from '@/mixins/keepAlive.js'
export default {
  name: 'Lostfound',
  mixins: [keepAlive],
  filters: {
    previewList: function (value) {
      return value.map((item) => {
        return item.filePrefix + item.fileUrl
      })
    }
  },
  data() {
    return {
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      tableData: [],
      searchForm: {
        itemName: '',
        projectName: '',
        state: ''
      },
      parkList: []
    }
  },
  created() {
    this.loadData()
    this.getPark()
  },
  methods: {
    // 获取公园列表
    getPark() {
      this.$axios.get(this.$apis.project.selectYhProjectByPage, {
        projectType: '4',
        page: 1,
        size: 100,
        isCad: 0
      }).then(res => {
        this.parkList = res.list || []
      })
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.tourist.selectLostAndFoundByPage, {
          page: this.page,
          size: this.size,
          ...this.searchForm
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onAdd() {
      this.$router.push('/lostfound/add')
    },
    onUpdate(id) {
      this.$router.push({
        name: 'LostfoundUpdate',
        params: { id }
      })
    },
    onSetting(row) {
      row.state = '1'
      this.$axios.post(this.$apis.tourist.updateLostAndFound, row).then(() => {
        this.loadData()
        this.$message.success('置为已领走')
      })
    },
    onDelete(id) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.tourist.deleteLostAndFound, {
          id
        }).then(() => {
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.el-image {
  width: 70px;
  height: 70px;
}
</style>
